__webpack_require__.p = "https://bundle.stayforlong.com/20251118.3/_next/";